/** Session-only flag: branch switch UI in header (production rollout gate). Default: off. */
const BRANCH_SWITCH_UI_SESSION_KEY = "garage360_branch_switch_ui_enabled";

export function getBranchSwitchUiEnabled(): boolean {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return false;
  }
  return sessionStorage.getItem(BRANCH_SWITCH_UI_SESSION_KEY) === "true";
}

export function setBranchSwitchUiEnabledSession(enabled: boolean): void {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.setItem(BRANCH_SWITCH_UI_SESSION_KEY, enabled ? "true" : "false");
}
